import { createClient } from '@supabase/supabase-js'
import { runtimeConfig } from 'src/config/runtime'

export const supabase = createClient(
  runtimeConfig.supabaseUrl,
  runtimeConfig.supabaseAnonKey
)
